import moment from 'moment-timezone';
Object.defineProperty(window, 'moment', { value: moment });
import 'moment/locale/fr.js';
